








































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import { FilledButton } from '@/components/molecules';
import PlusIcon from '@/components/icons/Plus.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';

@Component({
  components: {
    Typography,
    GhostButton,
    FilledButton,
    PlusIcon,
    ArrowRightInfoIcon
  }
})
export default class HomeOverviewCampaign extends Vue {
  @Prop() title!: string;
  @Prop() seeAllText!: string;
  @Prop() btnText!: string;
  @Prop({ default: true }) showPlusIcon!: boolean;
}
